var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import { mockDetailMatrix, mockFilters } from '../mock';
import StrategyMatrixText from '../../../../../../Viewer/canvas/StrategyMatrixText';
import styles from './PreviewElements.module.scss';
import { useActionsColors, useCommonTheme, useCurrentTheme } from '../../../../../../hooks/useCurrentTheme';
import { useMatrixFilterColor } from '../../../../../../hooks/useMatrixFilterColor';
import { fields } from '../../utils';
import { debounce } from 'lodash';
var PreviewDetailMatrix = function (_a) {
    var title = _a.title;
    var getColor = useActionsColors();
    var getFillColor = useMatrixFilterColor();
    var theme = useCurrentTheme();
    var isDrawReverseActions = useCommonTheme().isDrawReverseActions;
    var detailType = {
        actions: 'actions',
        range: 'value',
        ev: 'actions + value',
        equity: 'actions + value',
        eqr: 'value',
    };
    var maxVals = {
        range: 1,
        ev: 0.0854,
        equity: 0.95,
        eqr: 1.95,
        actions: 1,
    };
    var getGradient = function (actions) {
        var gradients = actions.map(function (action, index) {
            var color = getColor(action.title, index - 2, index === actions.length - 1);
            return "linear-gradient(to right, ".concat(color, " , ").concat(color, ")");
        });
        return isDrawReverseActions ? gradients.slice().reverse() : gradients;
    };
    var getSizeBack = function (actions, lastElement) {
        var gradientWidth = 0;
        var gradientWidthArray = [];
        var abs = lastElement ? 0.3 : 1;
        var reversed = isDrawReverseActions ? actions.slice().reverse() : actions;
        reversed.map(function (item) {
            var x = 100 * item.value;
            var defaultCellHeight = 100;
            var weightHeight = ((defaultCellHeight * abs) / defaultCellHeight) * 100;
            var weightWidth = x + gradientWidth;
            gradientWidth = weightWidth;
            gradientWidthArray.push("".concat(weightWidth, "% ").concat(weightHeight, "%"));
        });
        return gradientWidthArray;
    };
    var _b = useState({
        height: null,
        width: null,
    }), containerDimensions = _b[0], setContainerDimensions = _b[1];
    var refContainer = useRef(null);
    var elementObserver = useMemo(function () {
        return new ResizeObserver(function () {
            debounce(function () {
                if (!refContainer.current) {
                    return;
                }
                setContainerDimensions({
                    height: refContainer.current.offsetHeight,
                    width: refContainer.current.offsetWidth,
                });
            }, 0)();
        });
    }, [refContainer.current]);
    useEffect(function () {
        if (!refContainer.current) {
            return;
        }
        var element = refContainer.current;
        elementObserver.observe(element);
        return function () {
            elementObserver.unobserve(element);
        };
    }, [refContainer.current, elementObserver]);
    return (_jsx("div", __assign({ className: styles.detailMatrixPreview, ref: refContainer }, { children: mockDetailMatrix.map(function (item, index) {
            var img = getFillColor({
                field: fields[title],
                played: item[title],
                fieldMax: maxVals[title],
                fieldMin: 0,
                matrixRange: theme.matrix.range,
                matrixEquity: theme.matrix.equity,
                matrixEv: theme.matrix.ev,
                matrixEqr: theme.matrix.eqr,
                maxEquityRealization: maxVals[title],
                minEquityRealization: 0,
            });
            var size = index === mockDetailMatrix.length - 1 ? '100% 30%' : '100% 100%';
            return (_jsx("div", __assign({ style: {
                    backgroundSize: title === 'actions' ? getSizeBack(item.actions, index === mockDetailMatrix.length - 1).join(',') : size,
                    backgroundImage: title === 'actions'
                        ? getGradient(item.actions).join(',')
                        : "linear-gradient(to right, ".concat(img, " , ").concat(img, ")"),
                } }, { children: _jsx(StrategyMatrixText, { cards: item.cards, actions: item.actions, played: title !== 'actions' ? item[title] : 0, field: fields[title], detailType: detailType[title], filter: mockFilters, detailedMatrixDimensions: containerDimensions, matrixSizeX: 2, matrixSizeY: 2 }) }), item.ev));
        }) })));
};
export default PreviewDetailMatrix;
